export default __webpack_public_path__ + "static/media/Template1.29fc5fa3.png";